import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Trolley, Check, Box, Snail, Xmark, ShoppingCart, Wrench, Car, } from "@gravity-ui/icons";
import BoxCancelIcon from "../../../assets/BoxCancelIcon.svg";
export const getStatusIcon = (status) => {
    switch (status) {
        case "Котгрузке":
            return (_jsx(Trolley, { style: {
                    color: "rgba(100, 122, 141, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "Выдан":
            return (_jsx(Check, { style: {
                    color: "rgba(48, 170, 110, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "service.created":
            return (_jsx(Box, { style: {
                    color: "rgba(100, 122, 141, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "Втранзите":
            return (_jsx(Snail, { style: {
                    color: "rgba(100, 122, 141, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "Отказ":
            return (_jsx(Xmark, { style: {
                    color: "rgba(233, 3, 58, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "Взаказе":
            return (_jsx(ShoppingCart, { style: {
                    color: "rgba(100, 122, 141, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "Вработе":
            return (_jsx(Wrench, { style: {
                    color: "rgba(100, 122, 141, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "Впути":
            return (_jsx(Car, { style: {
                    color: "rgba(100, 122, 141, 1)",
                    verticalAlign: "sub",
                    marginRight: "4px",
                } }));
        case "Отменён":
        case "ОтмененоВами":
            return (_jsx(_Fragment, { children: _jsx("img", { src: BoxCancelIcon, alt: "", style: {
                        color: "rgba(233, 3, 58, 1)",
                        width: "16px",
                        height: "16px",
                        marginRight: "4px",
                        verticalAlign: "sub",
                    } }) }));
        default:
            return null;
    }
};
